import { FullPolicyData } from 'interfaces/customerDataTypes';
import { AnnualPayment } from './annualPayment/annualPayment';
import { MonthlyPayment } from './monthlyPayment/monthlyPayment';
import { Loading } from 'components/shared/loading';
import { useAppSelector } from 'store/hooks';
import { useEffect } from 'react';
import { PATH } from 'interfaces/pathTypes';
import { useHistory } from 'react-router-dom';

interface ConversionPaymentProps {
  selectedPolicy: FullPolicyData;
  paymentFrequency: string | null;
  paymentAmount: string | null;
  policyDetailsId: string;
  historyId: string;
}

export const ConversionPayment = ({
  selectedPolicy,
  paymentFrequency,
  paymentAmount,
  policyDetailsId,
  historyId
}: ConversionPaymentProps): JSX.Element => {
  const policy = useAppSelector((state) => state.policy);
  const { renewPolicyLoading, renewPolicySuccess, renewPolicyError } = policy;
  const history = useHistory();

  useEffect(() => {
    if (renewPolicySuccess) {
      history.push(`${PATH.RENEWAL}/confirmation`);
    }
  }, [renewPolicySuccess]);

  useEffect(() => {
    if (renewPolicyError) {
      history.push(`${PATH.RENEWAL}/error`);
    }
  }, [renewPolicyError]);

  if (renewPolicyLoading) {
    return <Loading heading="Processing renewal" text="Please wait while we process your renewal." />;
  }

  return paymentFrequency === 'Yearly' ? (
    <AnnualPayment
      selectedPolicy={selectedPolicy}
      paymentAmount={Number(paymentAmount)}
      policyDetailsId={policyDetailsId}
      historyId={Number(historyId)}
    />
  ) : (
    <MonthlyPayment selectedPolicy={selectedPolicy} policyDetailsId={policyDetailsId} historyId={Number(historyId)} />
  );
};
